import { css, html, LitElement } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
// import '../ChatTile/ChatTile';
import '../ContactTile/ContactTile';
import { Image } from '../Image/Image';
import './MediaList';
import { generateProfileImageByInitials } from '../../../lib/helpers';
import { WEB_CONTENT } from '../../../constants/content';
import '../MembersList/MembersList';
import { groupMembersStore } from '../../../store/group-members';
import '../../../stories/Components/MessageBubble/LinkMessageBubble/LinkMessageBubble';
import { drawerDialogService } from '../Dialog-Drawer/dialog-drawer';
import {getGroupcastUrlQuery} from '../../../lib/helpers'
class ContactInfo extends LitElement {
  static properties = {
    //strings
    padding: { type: String },
    margin: { type: String },
    width: { type: String },
    boxShadow: { type: String },
    height: { type: String },
    borderRadius: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    backgroundColor: { type: String },
    textColor: { type: String },
    fontSize: { type: String },
    fontWeight: { type: String },
    fontFamily: { type: String },
    fontStyle: { type: String },
    lineHeight: { type: String },
    textAlign: { type: String },
    contactImage: { type: String },
    contactName: { type: String },
    contactEmail: { type: String },
    messageAction: { type: Object },

    //arrays
    groupMembers: { type: Array },
    allAttachments: { type: Array },

    //booleans
    isGroup: { type: Boolean },
    showAllMembers: { type: Boolean },
    isPopupOpen: { type: Boolean },
    showMediaList: { type: Boolean },
    isImageFullscreen: { type: Boolean },
    showConfirmationPopup: { type: Boolean },
    confirmationAction: { type: String },
    conversationId: { type: String, reflect: true, mutable: true },
    oppenentId: { type: String, reflect: true },
    userMetaData: { type: Object },
    onEditTitle: { type: Function },
    onEditImage: { type: Function },
    onEditImage: { type: Function },
    openOwnProfile: { type: Boolean },
    editedName: { type: String },
    eligibleMembers: { type: Array },
    isEligibleMembersPopupOpen: { type: Boolean },
    hasMoreEligibleMembers: { type: Boolean },
    isLoadingMembers: { type: Boolean },
    activeTab: { type: String },
    docsAttachments: { type: Array },
    linksAttachments: { type: Array },
    allLinks: { type: Array },
    allLinksCount: { type: Number },
    isBlocked: { type: Boolean | String },
    conversationMetaData: { type: Object },
    isGroupcast: {type: Boolean},
    groupcastId: {type: String},
    groupcastMembers: {type: Array}
  };

  static styles = css`
    :host {
      width: 100%;
    }
    .contact-info-container {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
    }
    .popup-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }
    .popup-content {
      background: var(--bg-primary-color);
      padding: 14px;
      border-radius: 8px;
      width: 28%;
      max-height: 80vh;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 16px;
    }
    .popup-body {
      padding: 0 16px;
    }

    .popup-body-buttons {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    .popup-body button {
      border: none;
      font-size: 16px;
      color: var(--text-primary-color);
      cursor: pointer;
      width: 50%;
      padding: 10px 0px;
    }

    .popup-body button:last-child {
      background: transparent;
      border: 1px solid var(--text-primary-color);
      border-radius: 20px;
    }
    .popup-body button:first-child {
      background: var(--text-primary-color);
      border-radius: 20px;
    }
    .contact-info-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 20px;
      font-size: 18px;
      background: inherit;
      position: sticky;
      top: 0;
      z-index: 10;
      background: var(--bg-primary-color);
    }

    .contact-info-body {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      background: inherit;
      overflow-y: auto;
      flex-grow: 1;
    }

    .contact-info-body::-webkit-scrollbar {
      width: 4px;
    }

    .contact-info-body::-webkit-scrollbar-thumb {
      background-color: var(--text-primary-color);
      border-radius: 10px;
    }

    .contact-info-body::-webkit-scrollbar-track {
      background: var(--bg-primary-color);
      border-radius: 10px;
    }

    .contact-info {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-direction: column;
      padding: 1.5rem;
    }

    .contact-info-name {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .contact-info-name span:first-child {
      font-size: 20px;
      font-weight: 600;
    }

    .contact-info-name span:last-child {
      font-size: 16px;
      font-weight: 400;
    }
    .contact-media {
      padding: 16px;
      background: inherit;
    }

    .contact-media-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
    }
    contact-media-header-label {
      font-size: 14px;
    }

    .contact-media-header-count {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .contact-media-body {
      display: flex;
      gap: 10px;
      overflow: hidden;
      padding: 10px;
    }
    .shimmer-loader {
      width: 50%;
      height: 40px;
      position: relative;
      overflow: hidden;
    }

    .shimmer-line {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, var(--bg-secondary-color) 25%, var(--bg-primary-light) 50%, var(--bg-secondary-color) 75%);
      animation: shimmer 1.5s infinite;
    }

    @keyframes shimmer {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }
    .members-list {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;
      width: 25%;
      min-width: var(--sidebar-width);
    }

    .popup-members {
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-height: calc(80vh - 50px);
      overflow-y: auto;
    }

    .popup-members::-webkit-scrollbar {
      width: 4px;
    }

    .popup-members::-webkit-scrollbar-track {
      background: transparent;
    }

    .popup-members::-webkit-scrollbar-thumb {
      background-color: var(--bg-primary-light);
      border-radius: 3px;
    }

    .group-members-popup-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      position: absolute;
      bottom: 0px;
      background: var(--bg-secondary-color);
      z-index: 1;
      padding: 10px;
      left: 0;
      margin: 10px;
      width: -webkit-fill-available;
      justify-content: center;
      cursor: pointer;
    }

    .group-members-popup {
      position: relative;
    }

    .group-members-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 16px;
    }

    .group-members-header svg {
      cursor: pointer;
    }

    .group-members {
      padding: 16px;
      background: inherit;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
    }

    .ctas {
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: var(--bg-primary-color);
    }

    .ctas button {
      border: none;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 20px;
      cursor: pointer;
      width: 100%;
      font-size: 16px;
      background: transparent;
      color: var(--text-primary-color);
    }

    .ctas button:hover {
      color: var(--base-color);
    }

    .fullscreen-image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .fullscreen-image-container img {
      position: relative;
    }

    .contact-media-body img {
      cursor: pointer;
    }

    .contact-media-body img:hover {
      scale: 1.05;
    }

    .group-members chat-tile:hover {
      background: var(--bg-primary-light);
      cursor: pointer;
      border-radius: 8px;
    }

    .popup-members chat-tile:hover {
      background: var(--bg-primary-light);
      cursor: pointer;
      border-radius: 8px;
    }

    .profile-image-container {
      position: relative;
      cursor: pointer;
    }

    .profile-image-container:hover .image-edit-overlay {
      opacity: 1;
    }

    .image-edit-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .name-edit-input:focus {
      background: var(--bg-primary-light);
    }

    .nav-container {
      width: 100%;
      background-color: var(--bg-secondary-color);
      padding: 16px 0;
    }

    /* Inner container for max width */
    .inner-container {
      max-width: 1024px;
      margin: 0 auto;
      padding: 0 16px;
    }

    /* Tab styling */
    .tabs {
      display: flex;
      gap: 32px;
    }

    /* Tab item styling */
    .tab-item {
      position: relative;
      cursor: pointer;
    }

    /* Radio buttons (hidden) */
    .tab-radio {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    /* Tab labels */
    .tab-label {
      display: inline-block;
      color: #9ca3af;
      font-size: 18px;
      padding: 4px 0;
      transition: color 0.3s ease;
    }

    /* Underline indicator */
    .tab-indicator {
      position: absolute;
      bottom: -16px;
      left: 0;
      width: 100%;
      height: 4px;
      background-color: var(--base-color);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    /* When radio is checked */
    .tab-radio:checked + .tab-label {
      color: var(--base-color);
    }

    .tab-radio:checked ~ .tab-indicator {
      transform: scaleX(1);
    }

    /* Focus styles for accessibility */
    .tab-radio:focus + .tab-label {
      outline-offset: 2px;
    }
    .doc-item {
      display: flex;
      align-items: center;
      background: var(--bg-primary-light);
      margin: 8px 0;
      padding: 12px;
      border-radius: 8px;
      cursor: pointer;
    }

    .doc-item:hover {
      background: var(--bg-secondary-color);
    }

    .doc-icon {
      margin-right: 12px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .doc-info {
      flex-grow: 1;
      overflow: hidden;
    }

    .doc-name {
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 4px;
    }

    .doc-meta {
      display: flex;
      font-size: 12px;
      color: var(--text-secondary-color);
    }

    /* Link item styles */
    .link-item {
      display: flex;
      margin: 8px 0;
      border-radius: 8px;
      overflow: hidden;
      text-decoration: none;
      color: inherit;
    }

    .link-item:hover {
      background: var(--bg-secondary-color);
    }

    .link-preview {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .link-info {
      padding: 12px;
      flex-grow: 1;
      overflow: hidden;
    }

    .link-title {
      font-weight: 500;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .link-url {
      font-size: 12px;
      color: var(--text-secondary-color);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .no-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 200px;
      color: var(--text-secondary-color);
      text-align: center;
      padding: 0 20px;
    }

    .no-content svg {
      margin-bottom: 16px;
      opacity: 0.5;
    }

    /* Month separator */
    .month-separator {
      font-size: 14px;
      font-weight: 500;
      margin: 24px 0 12px 0;
      padding-left: 8px;
    }

    .shimmer {
      background: linear-gradient(90deg, var(--bg-secondary-color) 25%, var(--bg-primary-light) 50%, var(--bg-secondary-color) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite linear;
    }

    .member-shimmer {
      height: 60px;
      border-radius: 8px;
      margin: 8px 16px;
      opacity: 0.7;
    }

    @keyframes shimmer {
      0% {
        background-position: 100% 0;
      }
      100% {
        background-position: -100% 0;
      }
    }
  `;

  constructor() {
    super();
    this.lastConversationId = null;
    this.isEditingName = false;
    this.editedName = '';
    this.isLoadingMembers = true;
    this.activeTab = 'media';
    this.conversationMetaData = {};
    // Sample data for docs and links
    this.docsAttachments = [];
    this.linksAttachments = [];

    const urlParams = new URLSearchParams(window.location.search);
    this.isGroupcast = urlParams.has('groupcast')
    this.groupcastId = urlParams.get('groupcast')
  }
  willUpdate(changedProperties) {
    if (changedProperties.has('conversationId')) {
      this.handleConversationIdChange(this.conversationId, changedProperties.get('conversationId'));
    }
    if (changedProperties.has('groupMembers')) {
      const newConversationId = this.getConversationIdFromUrl();
      groupMembersStore.initializeMembers(this.groupMembers, newConversationId);
    }
  }

  handleConversationIdChange(newValue, oldValue) {
    if (newValue !== groupMembersStore.getCurrentConversationId()) {
      this.isLoadingMembers = true;
      groupMembersStore.initializeMembers(this.groupMembers, newValue);
    }

    const newConversationId = this.getConversationIdFromUrl();
    if (this.lastConversationId && this.lastConversationId !== newConversationId) {
      this._handleClose();
    }

    this.lastConversationId = newConversationId;
  }

  toggleShowAllMembers() {
    this.showAllMembers = !this.showAllMembers;
  }

  showMembersPopup() {
    this.isPopupOpen = true;
  }

  closeMembersPopup() {
    this.isPopupOpen = false;
  }

  toggleMediaList() {
    this.showMediaList = !this.showMediaList;
  }

  toggleImageFullscreen() {
    this.isImageFullscreen = !this.isImageFullscreen;
  }

  _handleClose() {
    if (this.showMediaList) {
      this.showMediaList = false;
      return;
    }
    this.dispatchEvent(
      new CustomEvent('close-right-Sidebar', {
        detail: {
          type: 'close-right-Sidebar',
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  getConversationIdFromUrl() {
    const url = new URL(window.location.href);
    return url.searchParams.get('conversation');
  }

  exitGroup() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'exit-group',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  clearChat() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'clear-chat',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  blockContact() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'block-contact',
          oppenentId: this.oppenentId,
          userName: this.contactName,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
  unblockContact() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'unblock-contact',
          oppenentId: this.oppenentId,
          userName: this.contactName,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  deleteChat() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'delete-chat',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  deleteGroupcast() {
    const urlParams = new URLSearchParams(window.location.search);
    const groupcastId = urlParams.get('groupcast');

    this.dispatchEvent(
      new CustomEvent('delete-groupcast', {
        detail: {
          groupcastId: groupcastId,
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );

    drawerDialogService.closeDialog();
    this._handleClose()
  }
  openConfirmationPopup(action, title) {
    drawerDialogService.openDialog('confirm-dialog', {
      title: `${title}`,
      description: `Are you sure you want to ${title} ?`,
      handleConfirm: () => this.confirmAction(action),
    });
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this._handleClose();
  }

  confirmAction(action) {
    switch (action) {
      case 'delete-groupcast':
        this.deleteGroupcast();
        break; 
      case 'delete-chat':
        this.deleteChat();
        break;
      case 'exit-group':
        this.exitGroup();
        break;
      case 'clear-chat':
        this.clearChat();
        break;
      case 'block-contact':
        this.blockContact();
        break;
      case 'unblock-contact':
        this.unblockContact();
        break;
      // Add more cases if needed
    }
    this.closeConfirmationPopup();
  }

  _handleKebabMenuClick(e) {
    e.stopPropagation();
  }

  shouldShowMemberActions(memberId) {
    const currentUserMember = this.groupMembers?.find(m => m.userId === this.userMetaData?.userId);
    return currentUserMember?.isAdmin ? this.userMetaData?.userId !== memberId : false;
  }

  handleNameClick() {
    if (this.isGroup ||  this.isGroupcast) {
      this.isEditingName = true;
      this.editedName = this.contactName;
      setTimeout(() => {
        const input = this.shadowRoot.querySelector('.name-edit-input');
        if (input) {
          input.focus();
          input.select();
        }
      }, 0);
    }
  }

  handleNameInputKeyDown(e) {
    if (e.key === 'Enter') {
      this.saveName();
    } else if (e.key === 'Escape') {
      this.isEditingName = false;
    }
  }

  saveName() {
    if (this.editedName.trim() && this.editedName !== this.contactName) {
      const oldName = this.contactName;
      this.contactName = this.editedName.trim();

      this.dispatchEvent(
        new CustomEvent('edit-title', {
          detail: {
            currentTitle: oldName,
            newTitle: this.editedName.trim(),
            conversationId: this.conversationId,
            onError: () => {
              // Revert on error
              this.contactName = oldName;
            },
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.isEditingName = false;
  }

  handleImageClick() {
    if (this.isGroup || this.isGroupcast) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = e => {
        const file = e.target.files?.[0];
        if (file) {
          const tempImageUrl = URL.createObjectURL(file);
          const oldImage = this.contactImage;

          this.contactImage = tempImageUrl;

          this.dispatchEvent(
            new CustomEvent('edit-image', {
              detail: {
                currentImage: oldImage,
                conversationId: this.conversationId,
                file: file,
                onError: () => {
                  this.contactImage = oldImage;
                  URL.revokeObjectURL(tempImageUrl);
                },
                onSuccess: () => {
                  URL.revokeObjectURL(tempImageUrl);
                },
              },
              bubbles: true,
              composed: true,
            }),
          );
        }
      };
      input.click();
    }
  }

  handleAddMembersClick(e) {
    e.stopPropagation();
    drawerDialogService.openDialog('member-add', {
      title: 'Eligible Members',
      width: '100%',
      fontSize: '16px',
      textColor: 'var(--text-primary-color)',
      selectedConversationId: this.isGroupcast ? this.groupcastId : this.conversationId,
      isGroupcast: this.isGroupcast
    });
  }

  extractAttachmentsByType() {
    // Reset arrays
    this.docsAttachments = [];
    this.linksAttachments = [];
    if (!this.allAttachments || !this.allAttachments.length) return;
    this.allAttachments.forEach(attachment => {
      attachment?.attachments?.forEach(att => {
        if (att.mediaType === 3) {
          // Document type
          this.docsAttachments.push({
            ...att,
            date: attachment.sentAt,
            sender: attachment?.senderInfo?.userName,
          });
        } else if (attachment?.customType === 'AttachmentMessage:Link') {
          // Link type
          this.linksAttachments.push({
            ...att,
            date: attachment.sentAt,
            sender: attachment?.senderInfo?.userName,
          });
        }
      });
    });

    // Sort by date
    this.docsAttachments.sort((a, b) => new Date(b.date) - new Date(a.date));
    this.linksAttachments.sort((a, b) => new Date(b.date) - new Date(a.date));

    this.requestUpdate();
  }

  updated(changedProperties) {
    // Existing updated logic
    super.updated(changedProperties);

    // Add extraction of docs and links when attachments are updated
    if (changedProperties.has('allAttachments')) {
      this.extractAttachmentsByType();
    }
  }

  switchTab(tab) {
    this.activeTab = tab;
  }

  formatFileSize(bytes) {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  formatDate(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  getMonthYear(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  groupByMonth(items, isLinks = false) {
    const groups = {};
    items.forEach(item => {
      const monthYear = this.getMonthYear(isLinks ? item.sentAt : item.date);
      if (!groups[monthYear]) {
        groups[monthYear] = [];
      }
      groups[monthYear].push(item);
    });

    return groups;
  }

  renderNoContent(title, subtitle) {
    return html`
      <div class="tab-content active">
        <div class="no-content">
          <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24" width="48" fill="currentColor">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z" />
          </svg>
          <h3 style="margin: 0 0 8px 0;">${title}</h3>
          <p style="margin: 0;">${subtitle}</p>
        </div>
      </div>
    `;
  }

  renderTabContent() {
    if (this.activeTab === 'media') {
      const mediaFromAttachments = [];
      this.allAttachments?.forEach(attachment => {
        attachment?.attachments?.forEach(att => {
          if (att?.mediaUrl && (att.mediaType === 0 || att.mediaType === 1 || att.mediaType === 2)) {
            // Image/video type
            mediaFromAttachments.push(att.mediaUrl);
          }
        });
      });
      if (!mediaFromAttachments.length) {
        return this.renderNoContent('No Media', 'Share media with this chat to see them here.');
      }

      return html`
        <div class="tab-content active">
          <media-list
            .mediaArray=${mediaFromAttachments}
            padding="10px"
            bgColor=${this.backgroundColor}
            color=${this.textColor}
            style="width: 100%"
            borderRadius="10px"
            height="calc(100vh - 100px)"
          ></media-list>
        </div>
      `;
    } else if (this.activeTab === 'docs') {
      if (!this.docsAttachments.length) {
        return this.renderNoContent('No Documents', 'Share documents with this chat to see them here.');
      }

      const docsByMonth = this.groupByMonth(this.docsAttachments);

      return html`
        <div class="tab-content active">
          ${Object.keys(docsByMonth).map(
            month => html`
              <div class="month-separator">${month}</div>
              ${docsByMonth[month].map(
                doc => html`
                  <div class="doc-item" @click=${() => window.open(doc.mediaUrl, '_blank')}>
                    <div class="doc-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="currentColor">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM16 18H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                      </svg>
                    </div>
                    <div class="doc-info">
                      <div class="doc-name">${doc.name || 'Document'}</div>
                      <div class="doc-meta">
                        <span>${this.formatFileSize(doc.size)}</span>
                        <span style="margin: 0 6px;">•</span>
                        <span>${this.formatDate(doc.date)}</span>
                      </div>
                    </div>
                  </div>
                `,
              )}
            `,
          )}
        </div>
      `;
    } else if (this.activeTab === 'links') {
      if (!this.allLinks?.length) {
        return this.renderNoContent('No Links', 'URLs shared in this chat will appear here.');
      }

      const linksByMonth = this.groupByMonth(this.allLinks, true);

      return html`
        <div class="tab-content active">
          ${Object.keys(linksByMonth).map(
            month => html`
              <div class="month-separator">${month}</div>
              ${linksByMonth[month].map(
                link => html`
                  <a href=${link.body} target="_blank" class="link-item">
                    <div class="link-preview">
                      <link-preview .showReactionOnHover=${false} url=${link.body} time=${link.sentAt}></link-preview>
                    </div>
                  </a>
                `,
              )}
            `,
          )}
        </div>
      `;
    }
  }
  openProfile(member) {
    if (this.isPopupOpen) {
      this.isPopupOpen = false;
    }
    if (member.userId === this.userMetaData?.userId) {
      this.openOwnProfile();
    } else {
      this.dispatchEvent(
        new CustomEvent('open-right-Sidebar', {
          detail: {
            type: 'open-right-Sidebar',
            renderComponent: 'profile-info',
            userId: member.userId,
            userName: member.userName,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }
  render() {
    const headerFontSize = `calc(${this.fontSize} - 4px)`;
    const mediaFromAttachments = [];
    this.allAttachments?.forEach(attachment => {
      attachment?.attachments?.forEach(att => {
        if (att?.mediaUrl) {
          mediaFromAttachments.push(att.mediaUrl);
        }
      });
    });
    const members = groupMembersStore.getMembers();
    this.isLoadingMembers = !members;

    const urlParams = new URLSearchParams(window.location.search);
    const isGroupcast = urlParams.has('groupcast');

    return html`
      <div
        class="contact-info-container"
        style=${styleMap({
          padding: this.padding,
          margin: this.margin,
          width: this.width,
          height: this.height,
          borderRadius: this.borderRadius,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor,
          borderStyle: this.borderStyle,
          backgroundColor: this.backgroundColor,
          color: this.textColor,
          fontSize: this.fontSize,
          fontWeight: this.fontWeight,
          fontFamily: this.fontFamily,
          fontStyle: this.fontStyle,
          lineHeight: this.lineHeight,
          boxShadow: this.boxShadow,
          textAlign: this.textAlign,
        })}
      >
        ${this.showMediaList
          ? html`
              <div class="contact-info-header">
                <svg
                  @click=${this._handleClose}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="${this.textColor}"
                  style="cursor: pointer;"
                >
                  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                </svg>
              </div>
              <div>
                <div class="nav-container">
                  <div class="inner-container">
                    <div class="tabs">
                      <div class="tab-item">
                        <input type="radio" id="tab-media" name="tabs" class="tab-radio" ?checked=${this.activeTab === 'media'} @change=${() => this.switchTab('media')} />
                        <label for="tab-media" class="tab-label">Media</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'media' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>

                      <div class="tab-item">
                        <input type="radio" id="tab-docs" name="tabs" class="tab-radio" ?checked=${this.activeTab === 'docs'} @change=${() => this.switchTab('docs')} />
                        <label for="tab-docs" class="tab-label">Docs</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'docs' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>

                      <div class="tab-item">
                        <input
                          type="radio"
                          id="tab-links"
                          name="tabs"
                          class="tab-radio"
                          ?checked=${this.activeTab === 'links'}
                          @change=${() => this.switchTab('links')}
                          @click=${() =>
                            this.dispatchEvent(
                              new CustomEvent('get-links', {
                                detail: {
                                  conversationId: this.conversationId,
                                },
                                bubbles: true,
                                composed: true,
                              }),
                            )}
                        />
                        <label for="tab-links" class="tab-label">Links</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'links' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>
                    </div>
                  </div>
                </div>

                ${this.renderTabContent()}
              </div>
            `
          : html`
              <div class="contact-info-header">
                <svg
                  @click=${this._handleClose}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="${this.textColor}"
                  style="cursor: pointer;"
                >
                  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                </svg>
                ${this.isGroup ? html`<span class="group-info-label">Group Info</span>` : html`<span class="contact-info-label">Contact Info</span>`}
              </div>

              <div class="contact-info-body">
                <div class="contact-info" style="background: var(--bg-primary-color);">
                  <div style="position: relative; display: flex; align-items: center; gap: 8px;">
                    ${Image({
                      src: this.contactImage,
                      width: 'calc(75dvh - 300px)',
                      height: 'calc(75dvh - 300px)',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      placeholderImage: generateProfileImageByInitials(this.contactImage),
                    })}
                    ${this.isGroup 
                      ? html`
                          <div
                            @click=${this.handleImageClick}
                            style="
                             position: absolute;
                             right: 15%;
                             bottom: 0;
                             transform: translateY(-50%);
                             cursor: pointer;
                             padding: 8px;
                             border-radius: 50%;
                             background: var(--bg-primary-light);
                           "
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                              <path
                                d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                              />
                            </svg>
                          </div>
                        `
                      : ''}
                  </div>
                  <div class="contact-info-name">
                    ${this.isGroup
                      ? this.isEditingName
                        ? html`
                            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
                              <input
                                type="text"
                                .value=${this.editedName}
                                @input=${e => (this.editedName = e.target.value)}
                                @keydown=${this.handleNameInputKeyDown}
                                class="name-edit-input"
                                style="
                            font-size: 20px;
                            font-weight: 600;
                            background: transparent;
                            border: none;
                            border-bottom: 2px solid var(--text-primary-color);
                            color: var(--text-primary-color);
                            text-align: center;
                            width: 100%;
                            padding: 4px;
                            outline: none;
                          "
                              />
                              <svg @click=${this.saveName} xmlns="http://www.w3.org/2000/svg" height="35px" viewBox="0 -960 960 960" width="36px" fill="var(--text-primary-color)">
                                <path
                                  d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
                                />
                              </svg>
                            </div>
                          `
                        : html`
                            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;" @click=${this.handleNameClick}>
                              <span>${this.contactName}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor">
                                <path
                                  d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                                />
                              </svg>
                            </div>
                          `
                      : html` <span>${this.contactName}</span> `}
                    <span>${this.contactEmail}</span>
                  </div>
                </div>

                <div class="contact-media" style="background: var(--bg-primary-color);">
                  <div class="contact-media-header">
                    <span class="contact-media-header-label">Media, links and docs</span>
                    <div class="contact-media-header-count" @click=${this.toggleMediaList}>
                      <span>${this.allLinksCount || this.allAttachments?.length}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="${this.textColor}">
                        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                      </svg>
                    </div>
                  </div>
                </div>

                ${this.isGroup || this.isGroupcast
                  ? html`<div class="group-members" style="background: var(--bg-primary-color);">
                        <div class="group-members-header">
                          <span class="group-members-header-label" style="font-size: 18px;">${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.TITLE}</span>
                          ${this.groupMembers?.find(m => m.userId === this.userMetaData?.userId)?.isAdmin ||  this.isGroupcast
                            ? html`
                                <svg
                                  @click=${this.handleAddMembersClick}
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="24px"
                                  viewBox="0 -960 960 960"
                                  width="24px"
                                  fill="var(--text-primary-color)"
                                >
                                  <path
                                    d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Z"
                                  />
                                </svg>
                              `
                            : ''}
                        </div>
                        ${this.isLoadingMembers
                          ? html` <div style="padding: 0 0px;">${[1, 2, 3].map(() => html` <div class="member-shimmer shimmer"></div> `)}</div> `
                          : html` ${Array.isArray(this.isGroupcast ? this.groupcastMembers : members)
                              ? (this.isGroupcast ? this.groupcastMembers : members).slice(0, 8).map(
                                  member => html`
                                    <div>
                                      <contact-tile
                                        contactName="${member.userId === this.userMetaData?.userId ? 'You' : member.userName || member?.memberInfo?.userName}"
                                        imageSrc="${member.userProfileImageUrl || member?.memberInfo?.userProfileImageUrl}"
                                        .suffix=${member.isAdmin ? 'Admin' : ''}
                                        suffixBgColor="var(--bg-secondary-color)"
                                        suffixColor="var(--text-primary-color)"
                                        bgColor="inherit"
                                        padding="10px"
                                        borderWidth="0px"
                                        .isCheckBox=${false}
                                        gap="10px"
                                        .showActions=${this.shouldShowMemberActions(member.userId) || this.isGroupcast}
                                        .userId=${member?.userId || member?.memberId}
                                        .isAdmin=${member?.isAdmin || this.isGroupcast}
                                        @name-clicked=${e => this.openProfile(e.detail)}
                                        .isGroupcast=${this.isGroupcast}
                                      ></contact-tile>
                                    </div>
                                  `,
                                )
                              : ''}`}
                        ${Array.isArray(members || this.groupcastMembers) && (members || this.groupcastMembers).length > 8
                          ? html`<button
                              style="border: none; background: transparent; cursor: pointer; padding: 10px; width: 100%; text-decoration: underline; color:var(--text-primary-color);"
                              @click="${this.showMembersPopup}"
                            >
                              View All Members (${(members || this.groupcastMembers).length})
                            </button>`
                          : ''}
                      </div>

                      ${this.isPopupOpen
                        ? html`
                            <div class="popup-overlay">
                              <div class="popup-content group-members-popup">
                                <div class="popup-header">
                                  <span style="color: ${this.textColor};">${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.TITLE}</span>
                                  ${this.groupMembers?.find(m => m.userId === this.userMetaData?.userId)?.isAdmin || this.isGroupcast
                                    ? html`
                                        <div class="group-members-popup-actions">
                                          <span>${WEB_CONTENT.CHAT.GROUP_INFO.GROUP_MEMBERS.ADD_MEMBER}</span>
                                          <svg
                                            @click=${this.handleAddMembersClick}
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24px"
                                            viewBox="0 -960 960 960"
                                            width="24px"
                                            fill="var(--text-primary-color)"
                                          >
                                            <path
                                              d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Z"
                                            />
                                          </svg>
                                        </div>
                                      `
                                    : ''}
                                  <button class="close-btn" @click="${this.closeMembersPopup}">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${this.textColor}">
                                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                                    </svg>
                                  </button>
                                </div>
                                <div class="popup-members">
                                  ${(this.isGroupcast? this.groupcastMembers : this.groupMembers).map(
                                    member => html`
                                      <div>
                                        <contact-tile
                                          contactName="${member.userName || member.memberInfo?.userName}"
                                          imageSrc="${member.userProfileImageUrl || member.memberInfo?.userProfileImageUrl}"
                                          .suffix=${member.isAdmin ? 'Admin' : ''}
                                          suffixBgColor="var(--bg-secondary-color)"
                                          suffixColor="var(--text-primary-color)"
                                          bgColor="inherit"
                                          padding="10px"
                                          borderWidth="0px"
                                          .isCheckBox=${false}
                                          gap="10px"
                                          .showActions=${this.shouldShowMemberActions(member.userId) || this.isGroupcast}
                                          .userId=${member.userId || member.memberId}
                                          @name-clicked=${e => this.openProfile(e.detail)}
                                          .isGroupcast=${this.isGroupcast}
                                        />
                                      </div>
                                    `,
                                  )}
                                </div>
                              </div>
                            </div>
                          `
                        : ''}`
                  : ''}
              </div>
            `}
        ${!isGroupcast
          ? html`
                <div class="ctas">
          ${
            this.showMediaList
              ? null
              : this.isGroup
                ? html`
                    <button @click="${() => this.openConfirmationPopup('exit-group', 'exit group')}">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${this.textColor}">
                        <path
                          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"
                        />
                      </svg>
                      Exit Group
                    </button>
                  `
                : html`
                    <button @click="${() => this.openConfirmationPopup('clear-chat', 'Clear Chat')}">Clear Chat</button>
                    ${this.conversationMetaData.messagingDisabled && this.isBlocked
                      ? html`<button style="color: var(--text-danger-color);" @click="${() => this.openConfirmationPopup('unblock-contact', 'Unblock Chat')}">Unblock Chat</button>`
                      : !this.conversationMetaData.messagingDisabled && this.isBlocked === null
                        ? html`<button style="color: var(--text-danger-color);" @click="${() => this.openConfirmationPopup('block-contact', 'Block Chat')}">Block Chat</button>`
                        : this.isBlocked === 'loading'
                          ? html`<div class="shimmer-loader">
                              <div class="shimmer-line"></div>
                            </div>`
                          : null}
                    <button style="color: var(--text-danger-color);" @click="${() => this.openConfirmationPopup('delete-chat', 'Delete Chat')}">Delete Chat</button>
                  `
          }
        </div>
              `
          : html`<div class="ctas">
                                 <button style="color: var(--text-danger-color);" @click="${() => this.openConfirmationPopup('delete-groupcast', 'Delete Groupcast')}">Delete Groupcast</button>

          </div>`}
      </div>
    `;
  }
}

customElements.define('contact-info', ContactInfo);
